import React, { useEffect, useState } from 'react';
import '../styles/global.css';
import { useNavigate } from 'react-router-dom';

export default function SuccessPage() {
  const [registrationData, setRegistrationData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = sessionStorage.getItem('roboKidsWaiverSession') || localStorage.getItem('roboKidsRegistration');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setRegistrationData(parsed);
      } catch (err) {
        console.error("Failed to parse registration:", err);
      }
    }
  }, []);

  const handleGoToWaiver = () => {
    navigate('/waiver');
  };

  return (
    <div className="container">
      <h1>🎉 Payment Successful!</h1>

      {registrationData ? (
        <div style={{ marginTop: '1rem' }}>
          <p><strong>Guardian:</strong> {registrationData.guardianName}</p>
          <p><strong>Child:</strong> {registrationData.childName} ({registrationData.childAge})</p>
          <p><strong>Class Type:</strong> {registrationData.classType}</p>
          <p><strong>Class Date:</strong> {registrationData.startDate}</p>
          <p>✅ Next Step: Please complete the waiver below.</p>

          <button
            onClick={handleGoToWaiver}
            style={{
              marginTop: '1rem',
              padding: '0.75rem 1.5rem',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: 'bold'
            }}
          >
            ✍️ Complete Waiver Form
          </button>
        </div>
      ) : (
        <p>⚠️ Registration info not found. Please go back and try again.</p>
      )}
    </div>
  );
}
